var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import GraphLine from '../../components/ins-claim/graph-line.vue';
import GraphLine2 from '../../components/ins-claim/graph-line2.vue';
import GraphHistogram from '../../components/ins-claim/graph-histogram.vue';
import IndicatorOverview from '../../components/ins-claim/claim-indicators.vue';
import { transChartLine2, formDefaultSearchDate } from './trans-data-util';
import { chartLine, chartLine2, chartHistogram } from './chart-config';
import { toFixed } from '../../utils/unit-conversion';
import * as TIPS from './const-tips';
var MOCK_NUM = 30;
export default Vue.extend({
    components: {
        'chart-line': GraphLine,
        'chart-line2': GraphLine2,
        'chart-histogram': GraphHistogram,
        'el-indicator-overview': IndicatorOverview,
    },
    data: function () {
        return {
            searchDefaultParam: {},
            activeTab: 'tab-case',
            tipsGraph: TIPS.TipHomeClaimTrend,
            indicators: [
                {
                    span: 4,
                    label: '总出险次数',
                    value: '668',
                    type: 'line',
                    custFont: false,
                    tips: TIPS.TipHomeTotalClaim,
                },
                {
                    span: 4,
                    label: '满期出险率',
                    value: '40%',
                    type: 'progress',
                    custFont: false,
                    tips: TIPS.TipHomeExpiredClamRate,
                },
                {
                    span: 4,
                    label: '总赔款金额',
                    value: '0',
                    type: 'line',
                    custFont: false,
                    tips: TIPS.TipHomeTotalPaid,
                    color: '#876AD6',
                },
                {
                    span: 4,
                    label: '满期赔付率',
                    value: '52%',
                    type: 'progress',
                    custFont: false,
                    tips: TIPS.TipHomeExpiredPaidRate,
                },
                {
                    span: 4,
                    label: '万元以下赔付时效',
                    value: '3天5时',
                    type: 'bar',
                    custFont: true,
                    tips: TIPS.TipHomeEfficiency,
                },
            ],
            insCaseSum: '',
            insCaseAverage: '',
            payExpiredTop: '',
            payExpiredLow: '',
            payExpiredAver: '',
            insCaseOptions: __assign({}, chartLine),
            paymentOptions: __assign({}, chartLine2),
            payExpiredOptions: __assign({}, chartLine),
            payEfficiencyOptions: __assign({}, chartHistogram),
        };
    },
    methods: {
        initIndicatorDefault: function () {
            this.searchDefaultParam = formDefaultSearchDate();
        },
        handleTab: function (tab, event) {
            this.activeTab = tab.name;
            this.freshTabPage();
        },
        freshTabPage: function () {
            if (this.activeTab === 'tab-case') {
                this.tipsGraph = TIPS.TipHomeClaimTrend;
            }
            else if (this.activeTab === 'tab-payment') {
                this.tipsGraph = TIPS.TipHomePaidTrend;
            }
            else if (this.activeTab === 'tab-expired') {
                this.tipsGraph = TIPS.TipHomeExpiredTrend;
            }
            else if (this.activeTab === 'tab-efficiency') {
                this.tipsGraph = TIPS.TipHomeEfficiencyTrend;
            }
        },
        // 刷新整个页面
        onFreshPage: function () {
            this.freshTabPage();
        },
        randomValue: function (baseValue, maxValue, enumType) {
            if (enumType === void 0) { enumType = true; }
            if (enumType) {
                return baseValue + Math.round(Math.random() * (maxValue - baseValue));
            }
            else {
                return baseValue + toFixed(Math.random() * (maxValue - baseValue), 2);
            }
        },
        mockCase: function () {
            var dataset = [];
            var currentDate = moment();
            for (var i = MOCK_NUM; i >= 0; i--) {
                dataset.push({
                    xAxis: moment(currentDate)
                        .subtract(i, 'day')
                        .format('YYYY-MM-DD'),
                    yAxis: this.randomValue(6, 20),
                });
            }
            return dataset;
        },
        mockPaid: function () {
            var dataset = [];
            var currentDate = moment();
            for (var i = MOCK_NUM; i >= 0; i--) {
                dataset.push({
                    xAxis: moment(currentDate)
                        .subtract(i, 'day')
                        .format('YYYY-MM-DD'),
                    paid: this.randomValue(12000000, 58000000),
                    unpaid: this.randomValue(0, 16000000),
                });
            }
            return dataset;
        },
        mockOverdue: function () {
            var dataset = [];
            var currentDate = moment();
            for (var i = MOCK_NUM; i >= 0; i--) {
                dataset.push({
                    xAxis: moment(currentDate)
                        .subtract(i, 'day')
                        .format('YYYY-MM-DD'),
                    yAxis: this.randomValue(0, 7, false),
                });
            }
            return dataset;
        },
        mockAvgTime: function () {
            var dataset = [];
            var xAxis = ['0-2000', '2001-5000', '5001-10000', '10000+'];
            for (var i = 0; i < xAxis.length; i++) {
                dataset.push({
                    xAxis: xAxis[i],
                    yAxis: this.randomValue(28, 38),
                });
            }
            return dataset;
        },
        mockData: function () {
            this.insCaseOptions.data = this.mockCase();
            this.paymentOptions.data = transChartLine2(this.mockPaid());
            this.payExpiredOptions.data = this.mockOverdue();
            this.payEfficiencyOptions.data = this.mockAvgTime();
        },
        showError: function () {
            this.$confirm('您没有权限查看!', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                showCancelButton: false,
                center: true,
                customClass: 'classic-confirm',
            }).catch(function () { });
        },
    },
    mounted: function () {
        var _this = this;
        this.initIndicatorDefault();
        this.$store.dispatch('vinsurance/GET_INS_COMPANYS'); // 获取保险公司选项
        this.$store.dispatch('vinsurance/GET_RENT_COMPANYS'); // 获取保险公司选项
        this.activeTab = 'tab-case';
        this.payExpiredOptions.scale = [
            {
                dataKey: 'xAxis',
                alias: '日期',
            },
            {
                dataKey: 'yAxis',
                alias: '赔付率',
                formatter: function (value) { return value + '%'; },
            },
        ];
        this.mockData();
        this.onFreshPage();
        this.$nextTick(function () {
            _this.showError();
        });
    },
});
